import { connect } from "react-redux";
import PureComponent from "./component";
import { performSearch } from "../../actions/search";
import { closeDropdown } from "../../actions/dropdown";

const mapStateToProps = (state, ownProps) => ({
	options: state.options
});

const mapDispatchToProps = (dispatch, ownProps) => ({
	performSearch: options => performSearch(options, dispatch),
	closeDropdown: () => closeDropdown(dispatch)
});

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(PureComponent);
